/*
export function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}
*/

// 前端架构目前为根据 url 是否是 /mobile 来判断应用 mobile 的页面和 template，如果有判断真实设备的需求请单独写函数
export function isMobile() {
  if (window.location.pathname.startsWith(`${window.ICP_PUBLIC_PATH}mobile`)) return true;
  const type = getEnvType();
  return (
    type === ENV_TYPE.IOS ||
    type === ENV_TYPE.ANDROID ||
    type === ENV_TYPE.MOBILE_WECHAT ||
    type === ENV_TYPE.WECHAT_MINI
  );
}

// TODO
/* export function isPad() {
  return window.location.pathname.startsWith(`${window.ICP_PUBLIC_PATH}pad`);
} */

export const ENV_TYPE = {
  WECHAT: 'WeChat',
  MOBILE_WECHAT: 'MobileWeChat',
  WECHAT_MINI: 'WeChatMiniProgram',
  MACOS: 'macOS',
  IPADOS: 'iPadOS',
  IOS: 'iOS',
  ANDROID: 'Android',
  WINDOWS: 'Windows',
  LINUX: 'Linux',
  DEFAULT: 'Unknown',
};

function detectWeChat() {
  const ua = navigator.userAgent.toLowerCase();
  if (ua.includes('micromessenger')) {
    if (ua.includes('miniprogram')) return ENV_TYPE.WECHAT_MINI;
    if (ua.includes('mobile')) {
      return ENV_TYPE.MOBILE_WECHAT;
    }
    return ENV_TYPE.WECHAT;
  }
  return null;
}

export function isMacOs() {
  const ua = navigator.userAgent;
  // 使用 UA + maxTouchPoints 避免把 iPadOS 当成 macOS
  return /Macintosh|Mac OS X/i.test(ua) && navigator.maxTouchPoints <= 1;
}

export function getEnvType() {
  const wechat = detectWeChat();
  if (wechat) return wechat;

  const ua = navigator.userAgent;
  if (/iPhone|iPod/i.test(ua)) return ENV_TYPE.IOS;
  if (/iPad/i.test(ua) || (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1))
    return ENV_TYPE.IPADOS;
  if (/Android/i.test(ua)) return ENV_TYPE.ANDROID;
  if (isMacOs()) return ENV_TYPE.MACOS;
  if (/Windows/i.test(ua)) return ENV_TYPE.WINDOWS;
  if (/Linux/i.test(ua)) return ENV_TYPE.LINUX;

  return ENV_TYPE.DEFAULT;
}
